import { SumaDph } from './suma-dph';

/**
 * 
 * @export
 * @interface ProjektRozpocetFinancovanie
 */
export interface ProjektRozpocetFinancovanie {
    /**
     * 
     * @type {SumaDph}
     * @memberof ProjektRozpocetFinancovanie
     */
    'suma'?: SumaDph;
    /**
     * 
     * @type {string}
     * @memberof ProjektRozpocetFinancovanie
     */
    'zdrojFinancovania'?: ProjektRozpocetFinancovanieZdrojFinancovaniaEnum;
}

export const ProjektRozpocetFinancovanieZdrojFinancovaniaEnum = {
    Poo: 'POO',
    VlastneZdroje: 'VLASTNE_ZDROJE',
    StatnyRozpocet: 'STATNY_ROZPOCET',
    IneZdroje: 'INE_ZDROJE'
} as const;

export type ProjektRozpocetFinancovanieZdrojFinancovaniaEnum = typeof ProjektRozpocetFinancovanieZdrojFinancovaniaEnum[keyof typeof ProjektRozpocetFinancovanieZdrojFinancovaniaEnum];


